// extracted by mini-css-extract-plugin
export default {"blueBox":"blueBox_blueBox__MQHOD"};